import { render, staticRenderFns } from "./HistoricInfoMessage.vue?vue&type=template&id=41d205c8&scoped=true&"
import script from "./HistoricInfoMessage.vue?vue&type=script&lang=ts&"
export * from "./HistoricInfoMessage.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricInfoMessage.vue?vue&type=style&index=0&id=41d205c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d205c8",
  null
  
)

export default component.exports